import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../src/config";
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { useNavigate, useParams } from "react-router-dom";
import Cookies from 'js-cookie';
import 'bootstrap/dist/css/bootstrap.min.css';
import AdminGeralLayout from "../../components/AdminGeralLayout/AdminGeralLayout";

function RenovarMensalidade() {
  const { id } = useParams();
  const [cliente, setCliente] = useState(null);
  const [formData, setFormData] = useState({
    novaDataVencimento: "",
    novoValorMensalidade: "",
    enviarMensagemWhatsApp: true
  });

  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    carregarCliente();
  }, []);

  const carregarCliente = async () => {
    try {
      const token = Cookies.get("authToken");
      const response = await axios.get(`${API_BASE_URL}/admin-geral/clientes-master/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setCliente(response.data);
      
      // Define data de vencimento padrão (1 mês a partir de hoje)
      const dataAtual = new Date();
      dataAtual.setMonth(dataAtual.getMonth() + 1);
      const dataFormatada = dataAtual.toISOString().split('T')[0];

      setFormData({
        novaDataVencimento: dataFormatada,
        novoValorMensalidade: response.data.ValorMensalidade || "",
        enviarMensagemWhatsApp: true
      });

      setLoading(false);
    } catch (err) {
      console.error(err);
      setErro("Erro ao carregar cliente.");
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro("");
    setSucesso("");

    try {
      const token = Cookies.get("authToken");
      
      const payload = {
        novaDataVencimento: formData.novaDataVencimento || null,
        novoValorMensalidade: formData.novoValorMensalidade ? parseFloat(formData.novoValorMensalidade) : null,
        enviarMensagemWhatsApp: formData.enviarMensagemWhatsApp
      };

      const response = await axios.post(
        `${API_BASE_URL}/admin-geral/clientes-master/${id}/renovar`, 
        payload, 
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      setSucesso("Mensalidade renovada com sucesso!");
      setTimeout(() => {
        navigate("/admin-geral/clientes-master");
      }, 2000);

    } catch (err) {
      console.error(err);
      if (err.response && err.response.data && err.response.data.message) {
        setErro(err.response.data.message);
      } else {
        setErro("Erro ao renovar mensalidade.");
      }
    }
  };

  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
  };

  const formatarData = (data) => {
    if (!data) return "-";
    return new Date(data).toLocaleDateString('pt-BR');
  };

  if (loading) {
    return (
      <Container className="mt-5">
        <p>Carregando...</p>
      </Container>
    );
  }

  return (
    <AdminGeralLayout activeKeyProp="clientes-master">
      <div className="mb-4">
        <h1>Renovar Mensalidade</h1>
        <p className="text-muted">Renovação de mensalidade para o cliente: {cliente?.nome}.</p>
      </div>

      {loading ? (
        <p>Carregando...</p>
      ) : (
        <Container fluid className="p-0">
          {erro && <Alert variant="danger" onClose={() => setErro("")} dismissible>{erro}</Alert>}
          {sucesso && <Alert variant="success">{sucesso}</Alert>}

          {/* Informações do Cliente */}
        <Card className="shadow-sm" style={{width: "95%"}}>
            <Card.Header>
              <h5 className="mb-0">Informações do Cliente</h5>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col md={6}>
                  <p><strong>Nome:</strong> {cliente?.nome}</p>
                  <p><strong>Celular:</strong> {cliente?.celular}</p>
                  <p><strong>Email:</strong> {cliente?.email}</p>
                </Col>
                <Col md={6}>
                  <p><strong>Mensalidade Atual:</strong> {formatarMoeda(cliente?.valorMensalidade || 0)}</p>
                  <p><strong>Vencimento Atual:</strong> {formatarData(cliente?.dataVencimento)}</p>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Formulário de Renovação */}
        <Card className="shadow-sm" style={{width: "95%"}}>
            <Card.Header>
              <h5 className="mb-0">Dados da Renovação</h5>
            </Card.Header>
            <Card.Body>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Nova Data de Vencimento *</Form.Label>
                      <Form.Control
                        type="date"
                        name="novaDataVencimento"
                        value={formData.novaDataVencimento}
                        onChange={handleChange}
                        required
                      />
                      <Form.Text className="text-muted">
                        Padrão: 1 mês a partir de hoje
                      </Form.Text>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Novo Valor da Mensalidade (R$)</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.01"
                        name="novoValorMensalidade"
                        value={formData.novoValorMensalidade}
                        onChange={handleChange}
                        placeholder="Deixe em branco para manter o valor atual"
                      />
                      <Form.Text className="text-muted">
                        Atual: {formatarMoeda(cliente?.ValorMensalidade || 0)}
                      </Form.Text>
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    name="enviarMensagemWhatsApp"
                    label="Enviar mensagem de confirmação via WhatsApp"
                    checked={formData.enviarMensagemWhatsApp}
                    onChange={handleChange}
                  />
                  <Form.Text className="text-muted">
                    Uma mensagem será enviada ao cliente informando sobre a renovação.
                  </Form.Text>
                </Form.Group>

                <hr />

                <div className="d-flex justify-content-end">
                  <Button variant="secondary" className="me-2" onClick={() => navigate("/admin-geral/clientes-master")}>
                    Cancelar
                  </Button>
                  <Button variant="success" type="submit">
                    Confirmar Renovação
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Container>
      )}
    </AdminGeralLayout>
  );
}

export default RenovarMensalidade;
